import { JoinStatusEnum } from '@/app/request/_utils/types';
import { TeamLeagueOutstandingInvoice } from '@/infrastructure/dto/OutstandingInvoicesDto';
import { publicEnv } from '@/lib/env';

export const getRedirectUrl = (invoice: TeamLeagueOutstandingInvoice): string => {
	const { joinStatus, organizationUuid, teamLeagueUuid, seasonUuid, cartUuid, invitationCode } = invoice;
	let encodedCode = '';

	switch (joinStatus) {
		case JoinStatusEnum.JOIN_PLAYER_STATUS_TEAM_CREATION_JOIN:
			// Captain added user during team creation
			return `/request?orgId=${organizationUuid}&teamLeagueId=${teamLeagueUuid}&cartRecordId=${cartUuid}`;

		case JoinStatusEnum.JOIN_PLAYER_STATUS_INVITATION_CODE_JOIN:
			// Invited via email/dashboard code

			if (invitationCode) {
				try {
					encodedCode = btoa(invitationCode);
				} catch {
					encodedCode = '';
				}
			}
			return `${publicEnv.NEXT_PUBLIC_PTL_CHECKOUT_URL}/team-league/${organizationUuid}/${teamLeagueUuid}/${seasonUuid}/invitation?code=${encodedCode}`;

		case JoinStatusEnum.JOIN_PLAYER_STATUS_FREE_AGENT_JOIN:
			// FA request approved
			return `${publicEnv.NEXT_PUBLIC_PTL_CHECKOUT_URL}/team-league/${organizationUuid}/${teamLeagueUuid}/${seasonUuid}/${cartUuid}`;

		default:
			return '/';
	}
};
